import view from './view.html';

/* @ngInject */
export default function () {
	return {
		template:                   view,
		replace:                    true,
		scope:                      true,
		controller: /* @ngInject */ ($scope, STATUSES, $http, DataTablesService, moment, ReportsService, Reports, AuthService) => {
			$scope.apiURL = process.env.API_ENDPOINT;
			$scope.token  = AuthService.getToken();
			$scope.start  = $scope.parameters.start;
			$scope.end    = $scope.parameters.end;
			$scope.moment = moment;

			const financialYear = ReportsService.financialYear();

			if (!$scope.start) {
				$scope.start = financialYear.start;
			}

			if (!$scope.end) {
				$scope.end = financialYear.end;
			}

			$scope.status = STATUSES.UNLOADED;

			$scope.dataTable = DataTablesService.configure({
				id:                 $scope.reportId,
				title:              'Enquiries Report',
				frozenColumns:      true,
				reorderableColumns: true,
			}, {
				frozenLeftColumns:  3,
				frozenRightColumns: 2,
				order:              [
					[
						0,
						'desc',
					],
				],
			});

			$scope.data  = [];
			$scope.error = null;

			$scope.refresh = () => {
				$scope.status = STATUSES.LOADING;

				$scope.data  = [];
				$scope.error = null;

				return Reports.one($scope.reportId)
				              .one('execute')
				              .get({
					              start: $scope.start.format(),
					              end:   $scope.end.format(),
				              })
				              .then((data) => {
					              $scope.data  = data;
					              $scope.error = null;

					              $scope.status = STATUSES.LOADED;

					              return data;
				              })
				              .catch((error) => {
					              $scope.data  = [];
					              $scope.error = error;

					              $scope.status = STATUSES.ERRORED;
				              });
			};

			$scope.refresh();
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/report/reports/7164B78C-BF86-4E64-ACAE-F7EF2BF287ED/index.js